import { atom } from "jotai";

export const recentlyAddedHypothesisIdAtom = atom<string | null>(null);
